"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.StyledLayoutWrapperContainer=exports.StyledLayoutWrapper=exports.StyledLayoutSection=exports.StyledLayoutInner=exports.StyledLayoutHeader=exports.StyledLayoutFooter=exports.StyledLayoutContent=exports.StyledLayoutBlock=exports.StyledLayout=exports.StyledCustomAsideItemBadge=exports.StyledAsideToggle=exports.StyledAsideNav=exports.StyledAsideList=exports.StyledAsideLinkLabel=exports.StyledAsideLink=exports.StyledAsideItem=exports.StyledAsideIconContainer=exports.StyledAsideIcon=exports.StyledAside=void 0;var _styledComponents=_interopRequireDefault(require("styled-components"));require("./_style.css");require("../_themes/beeline/fonts/style.css");var _constants=require("../_constants");var _constants2=require("../Typography/_constants");var _utils=require("../Typography/_utils");var _constants3=require("./_constants");var _utils2=require("./_utils");var _AsideLink=_interopRequireDefault(require("./_internal/AsideLink"));function _interopRequireDefault(e){return e&&e.__esModule?e:{default:e};}const StyledLayout=exports.StyledLayout=_styledComponents.default.div`
  position: relative;
  box-sizing: border-box;
  height: 100%;
  min-width: ${_constants3.STYLES.MIN_WIDTH};
  display: flex;
  flex-flow: column nowrap;
  background: ${_ref=>{let{sBackground}=_ref;return(0,_utils2.getBlockBackground)(sBackground);}};
  font-family: ${_ref2=>{let{theme}=_ref2;return(0,_utils.getHeadingFontFamily)({theme});}};
  font-size: ${_ref3=>{let{theme}=_ref3;return(0,_utils.getFontSize)({theme,size:_constants2.REFS.SIZES.M,mediaSize:_constants.MEDIA_SIZES.S});}};
  line-height: ${_constants3.STYLES.FONT_SIZE};
  color: ${_ref4=>{let{theme}=_ref4;return(0,_utils.getColor)({theme,color:_constants2.REFS.COLORS.PRIMARY});}};

  @media (${_constants.MEDIA.TABLET}) {
    font-size: ${_ref5=>{let{theme}=_ref5;return(0,_utils.getFontSize)({theme,size:_constants2.REFS.SIZES.M,mediaSize:_constants.MEDIA_SIZES.M});}};
  }

  @media (${_constants.MEDIA.DESKTOP}) {
    font-size: ${_ref6=>{let{theme}=_ref6;return(0,_utils.getFontSize)({theme,size:_constants2.REFS.SIZES.M,mediaSize:_constants.MEDIA_SIZES.L});}};
    overflow: initial;
  }
`;const StyledLayoutBlock=exports.StyledLayoutBlock=_styledComponents.default.div`
  position: relative;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  background: ${props=>(0,_utils2.getBlockBackground)(props.sBackground)};
  padding: ${props=>props.withoutPadding?0:(0,_utils2.getBlockPadding)(_constants.MEDIA_SIZES.S)};

  @media (${_constants.MEDIA.TABLET}) {
    padding: ${props=>props.withoutPadding?0:(0,_utils2.getBlockPadding)(_constants.MEDIA_SIZES.M)};
  }

  @media (${_constants.MEDIA.DESKTOP}) {
    padding: ${props=>props.withoutPadding?0:(0,_utils2.getBlockPadding)(_constants.MEDIA_SIZES.L)};
  }
`;const StyledLayoutHeader=exports.StyledLayoutHeader=(0,_styledComponents.default)(StyledLayoutBlock)``;const StyledLayoutContent=exports.StyledLayoutContent=(0,_styledComponents.default)(StyledLayoutBlock)`
  flex-grow: 1;
  padding-bottom: 48px;

  @media (${_constants.MEDIA.TABLET}) {
    padding-bottom: initial;
  }
`;const StyledLayoutSection=exports.StyledLayoutSection=(0,_styledComponents.default)(StyledLayoutBlock)`
  margin: ${(0,_utils2.getSectionMargin)(_constants.MEDIA_SIZES.S)};
  padding: ${(0,_utils2.getSectionPadding)(_constants.MEDIA_SIZES.S)};

  :first-child {
    margin-top: ${(0,_utils2.getSectionFirstChildMarginTop)(_constants.MEDIA_SIZES.S)};
  }

  :last-child {
    margin-bottom: ${(0,_utils2.getSectionLastChildMarginBottom)(_constants.MEDIA_SIZES.S)};
  }

  @media (${_constants.MEDIA.TABLET}) {
    margin: ${(0,_utils2.getSectionMargin)(_constants.MEDIA_SIZES.M)};
    padding: ${(0,_utils2.getSectionPadding)(_constants.MEDIA_SIZES.M)};

    :first-child {
      margin-top: ${(0,_utils2.getSectionFirstChildMarginTop)(_constants.MEDIA_SIZES.M)};
    }

    :last-child {
      margin-bottom: ${(0,_utils2.getSectionLastChildMarginBottom)(_constants.MEDIA_SIZES.M)};
    }
  }

  @media (${_constants.MEDIA.DESKTOP}) {
    margin: ${(0,_utils2.getSectionMargin)(_constants.MEDIA_SIZES.L)};
    padding: ${(0,_utils2.getSectionPadding)(_constants.MEDIA_SIZES.L)};

    :first-child {
      margin-top: ${(0,_utils2.getSectionFirstChildMarginTop)(_constants.MEDIA_SIZES.L)};
    }

    :last-child {
      margin-bottom: ${(0,_utils2.getSectionLastChildMarginBottom)(_constants.MEDIA_SIZES.L)};
    }
  }
`;const StyledLayoutFooter=exports.StyledLayoutFooter=(0,_styledComponents.default)(StyledLayoutBlock)``;const StyledLayoutInner=exports.StyledLayoutInner=_styledComponents.default.div`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: ${props=>(0,_utils2.getBlockMaxWidth)(props.sMaxWidth)};
  margin: 0 ${props=>props.isCentered?'auto':0};
  display: ${props=>props.contentIsCentered?'flex':'block'};
  justify-content: ${props=>props.contentIsCentered?'center':'flex-start'};
  align-items: ${props=>props.contentIsCentered?'center':'flex-start'};
`;const StyledAsideNav=exports.StyledAsideNav=_styledComponents.default.nav`
  width: 100%;
  padding: 20px 15px;

  ${props=>!props.disableMediaDesktop&&`
    @media (${_constants.MEDIA.DESKTOP}) {
      padding: 0;
    }
  `}
`;const StyledAsideList=exports.StyledAsideList=_styledComponents.default.ul`
  padding: 0;
  margin: 0;
  flex-direction: column;
  transition: 0.5s;

  ${props=>!props.disableMediaDesktop&&`
    @media (${_constants.MEDIA.DESKTOP}) {
      overflow: initial;
      opacity: ${props.isOpen?1:0};
      max-height: ${props.isOpen?600:0}px;
    }
  `}
`;const StyledAsideItem=exports.StyledAsideItem=_styledComponents.default.li`
  width: 100%;
  text-decoration: none;
  list-style: none;
  position: relative;
`;const StyledAsideLink=exports.StyledAsideLink=(0,_styledComponents.default)(_AsideLink.default)`
  display: block;
  font-weight: ${props=>!props.level?'bold':'normal'};
  line-height: 30px;
  margin-bottom: 20px;
  font-family: ${_ref7=>{let{theme}=_ref7;return(0,_utils.getHeadingFontFamily)({theme});}};
  padding-left: ${props=>props.level*10}px;
  font-size: ${props=>[18,16,14][props.level]||18}px;
  text-decoration: none;
  color: ${_constants.COLORS.NIGHT_BLUE};

  ${props=>!props.disableMediaDesktop&&`
    @media (${_constants.MEDIA.DESKTOP}) {
      height: 50px;
      margin-bottom: 0;
      border-radius: 10px;
      background: ${props.isActiveStyle?_constants.COLORS.GRAYISH_BLUE_20:'inherit'};
      font-size: ${[14,13,12][props.level]||14}px;
      display: flex;
      position: relative;
  
      &:hover {
        background: ${_constants.COLORS.GRAYISH_BLUE_20};
        color: inherit;
      }
  
      &:after {
        content: '';
        top: 50%;
        right: 10px;
        width: 8px;
        height: 5px;
        position: absolute;
        transition: 0.5s;
        transform: translateX(-50%) rotate(${props.isOpen?0:-180}deg);
        display: ${props.withArrow?'block':'none'};
        background-image: url("data:image/svg+xml,%3Csvg width='8' height='5' viewBox='0 0 8 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 4L4 1L1 4' stroke='%23636363'/%3E%3C/svg%3E%0A");
      }
    }
  `}
`;const StyledAsideToggle=exports.StyledAsideToggle=_styledComponents.default.button`
  margin: 0 10px 0 0;
  padding: 0;
  border: none;
  outline: none;
  background: transparent;

  ${props=>!props.disableMediaDesktop&&`
    @media (${_constants.MEDIA.DESKTOP}) {
      display: none;
    }
  `}
`;const StyledAsideIcon=exports.StyledAsideIcon=_styledComponents.default.img`
  width: 100%;
`;const StyledAsideIconContainer=exports.StyledAsideIconContainer=_styledComponents.default.div`
  display: none;
  margin: 0 15px;
  max-width: 24px;
  min-width: 18px;

  ${props=>!props.disableMediaDesktop&&`
    @media (${_constants.MEDIA.DESKTOP}) {
      display: flex;
      align-items: center;
    }
  `}
`;const StyledAsideLinkLabel=exports.StyledAsideLinkLabel=_styledComponents.default.span`
  position: relative;

  &:before {
    content: '';
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 5px;
    background: rgba(255, 0, 0, 0.6);
    right: -15px;
    border: 2px solid rgba(255, 255, 255, 0.1);
    display: ${props=>props.badge?'block':'none'};

    ${props=>!props.disableMediaDesktop&&`
      @media (${_constants.MEDIA.DESKTOP}) {
        top: 15px;
      }
    `}
  }

  ${props=>!props.disableMediaDesktop&&`
    @media (${_constants.MEDIA.DESKTOP}) {
      line-height: 18px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
  `}
`;const StyledAside=exports.StyledAside=_styledComponents.default.aside`
  position: fixed;
  top: ${props=>props.top||59}px;
  height: calc(100vh - ${props=>props.top||59}px);
  transform: translateX(-${props=>props.isOpenAside?0:100}%);
  opacity: ${props=>props.isOpenAside?1:0};
  background: ${props=>props.isTransparent?'rgba(235, 237, 242, 0.9)':'rgb(235, 237, 242)'};
  z-index: 999;
  left: 0;
  width: fit-content;
  transition: 0.5s;
  padding-right: 25px;
  min-width: 170px;
  box-shadow: 5px 0 10px 0 rgba(0, 0, 0, 0.1);
  will-change: transform;
  overflow: auto;

  @media (${_constants.MEDIA.TABLET}) {
    top: ${props=>props.top||84}px;
    height: calc(100vh - ${props=>props.top||84}px);
  }
  ${props=>!props.disableMediaDesktop&&`
    @media (${_constants.MEDIA.DESKTOP}) {
      opacity: 1;
      width: 100%;
      top: auto;
      height: auto;
      position: relative;
      background: transparent;
      transform: translateX(0);
      padding-right: initial;
      box-shadow: none;
      overflow: initial;
      z-index: initial;
    }
  `}

  ${props=>props.isLight&&`
    ${StyledAsideLink} {
        color: ${_constants.COLORS.WHITE};
        &:after {
            background-image: url("data:image/svg+xml,%3Csvg width='8' height='5' viewBox='0 0 8 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 4L4 1L1 4' stroke='%23ffffff'/%3E%3C/svg%3E%0A");
          }
    }

    ${StyledAsideIconContainer} svg {
        fill: ${_constants.COLORS.WHITE};
        color: ${_constants.COLORS.WHITE};
    }
  `}
`;const StyledLayoutWrapper=exports.StyledLayoutWrapper=_styledComponents.default.div`
  transition: filter 800ms;
  filter: ${props=>props.isOpenAside?'blur(10px)':'none'};
`;const StyledLayoutWrapperContainer=exports.StyledLayoutWrapperContainer=_styledComponents.default.div`
  pointer-events: ${props=>props.disabled?'none':'auto'};
`;const StyledCustomAsideItemBadge=exports.StyledCustomAsideItemBadge=_styledComponents.default.div`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
`;